import { useMutation } from '@tanstack/react-query';
import { authApi } from './api';
import { useDispatch } from 'react-redux';
import { setCredentials, resetAuth } from '@/lib/authSlice';
import { useRouter } from 'next/navigation';

export const useLogin = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    return useMutation({
        mutationFn: authApi.login,

        onError: (error) => {
            console.error('Login failed', error);
        },
    });
};

export const useLogout = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    return useMutation({
        mutationFn: authApi.logout,
        onSettled: () => {
            dispatch(resetAuth());

            // Clear local storage for persistence if needed, though redux-persist handles it on state change usually.
            // But sometimes it's good to force purge if redux-persist is tricky.
            // For now, dispatch(resetAuth()) clears the state which updates storage.

            router.push('/');
        },
    });
};
